import React from 'react';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Box, Card, CardContent, Typography, Paper } from '@mui/material';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const STAGES = [
  "In Submission",
  "In Review",
  "In Process",
  "In Sanction",
  "In Disbursement",
  "All Statuses",
];

const stageColors = {
  "In Submission": "#f5c284",
  "In Review": "#83f0f4",
  "In Process": "#a6d0f5",
  "In Sanction": "#ffadad",
  "In Disbursement": "#cdb4db",
  "All Statuses": "#e0e0e0",
};
export default function StageWiseCostBarChart({ apiData = [] }) {
  const costMap = {};
  const callsMap = {};

  apiData.forEach((item) => {
    const name =typeof item.stageName === "string"
                ? item.stageName.trim()
                : "";
    if (name && STAGES.includes(name)) {
      costMap[name] = (costMap[name] || 0) + Number(item.totalCost || 0);
      callsMap[name] = (callsMap[name] || 0) + Number(item.totalCalls || 0);
    }

  });


  const labels = STAGES;
  const costs = STAGES.map((stage) => costMap[stage] || 0);
  const calls = STAGES.map((stage) => callsMap[stage] || 0);

  const getColor = (stage) => stageColors[stage] || '#9ca3af';

  const data = {
    labels,
    datasets: [
      {
        label: 'Total Cost',
        data: costs,
        backgroundColor: labels.map(getColor),
        borderColor: labels.map(getColor),
        borderWidth: 1,
        borderRadius: 0,
        barThickness: 18,
        borderSkipped: false,
      },
    ],
  };
  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: false },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        padding: 12,
        titleFont: { size: 14, weight: 'bold' },
        bodyFont: { size: 13 },
        callbacks: {
          label: function (context) {
            return `Total Cost: ₹${context.parsed.x.toLocaleString('en-IN')}`;
          }
        }
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Total Cost (₹)',
          font: { size: 14, weight: '500' },
          padding: { top: 12 },
        },
        beginAtZero: true,
        suggestedMax: Math.max(...costs) * 1.15,
        ticks: {
          callback: (value) => {
            return `₹${value.toLocaleString('en-IN')}`;
          },
          font: { size: 12 },
          maxTicksLimit: 6,
        },
        grid: {
          color: 'rgba(0,0,0,0.05)',
        },
      },
      y: {
        grid: { display: false },
        ticks: {
          font: { size: 13, weight: '500' },
          padding: 12,
        },
        categoryPercentage: 1.0,
        barPercentage: 1.0, 
      },
    },
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 3, pb: 1 }}>
   <Typography
                 variant="h5"
                 mb={1}
                 sx={{
                   display: "flex",
                   justifyContent: "center",
                 }}
               >
          <p style={{ fontFamily: 'Inter-Medium', color: '#667085', fontSize: '25px' }}>Stage Wise Costing</p>
               </Typography>

      
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: 1.5,
            mb: 1.5,
          }}
        >
          {STAGES.map((stage) => (
            <Box key={stage} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: 1.5,
                  bgcolor: getColor(stage),
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                }}
              />
              <Typography variant="body2" sx={{ color: '#667085', fontWeight: 500, fontSize: '0.813rem' }}>
                {stage}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Box sx={{ height: 250, px: 3, pb: 3 }}>
        <Bar data={data} options={options} />
      </Box>
    </Box>
  );
}